<template>
	<div id="container">
		<div class="search-container">
			<div class="search-input-group">
				<input type="text" v-model="searchLockNo" placeholder="输入车锁编号搜索" class="search-input" @input="onSearchInput" @keyup.enter="searchLock">
				<button @click="searchLock" class="search-button">搜索</button>
			</div>
		</div>
		<div class="search-tip">如果查询到多个车锁，再次点击搜索跳转下一个车锁位置</div>
		<div class="device-count" v-if="lockDeviceList.length > 0">当前区域: {{ lockDeviceList.length }} 台设备</div>
		<div class="fence-legend">
			<div class="legend-title">围栏类型</div>
			<div class="legend-item">
				<span class="legend-color return-color"></span>
				<span class="legend-text">还车围栏</span>
			</div>
			<div class="legend-item">
				<span class="legend-color operation-color"></span>
				<span class="legend-text">运营区域</span>
			</div>
		</div>
		<div id="map_view"></div>
	</div>
</template>
<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

const BATCH_SIZE = 200

export default {
	data() {
		return {
			lockDeviceList: [],
			allLockDeviceList: [],
			geometrieList: [],
			labelGeometries: [],
			map: null,
			markerLayer: null,
			highlightMarkerLayer: null,
			highlightLabelLayer: null,
			labelLayer: null,
			polygonLayer: null,
			searchLockNo: '',
			currentSearchIndex: -1,
			matchingLocks: [],
			electronicFenceList: [],
			fenceGeometrieList: [],
			queryDistributorId: '',
			boundsChangeTimer: null,
			renderTimer: null,
			currentBatchIndex: 0,
			pendingDevices: [],
			isLoadingDevices: false
		}
	},
	mounted() {
		this.queryDistributorId = getCurrentDistributorId()
		this.$nextTick(() => {
			setTimeout(() => {
				this.initMap();
				this.getElectronicFenceList();
			}, 100);
		});
	},
	beforeDestroy() {
		if (this.boundsChangeTimer) {
			clearTimeout(this.boundsChangeTimer);
		}
		if (this.renderTimer) {
			clearTimeout(this.renderTimer);
		}
		if (this.map) {
			this.map.destroy();
			this.map = null;
		}
	},
	methods: {
		initMap() {
			if (this.map) {
				try {
					this.map.destroy();
				} catch (e) {
					console.warn('销毁地图失败:', e)
				}
				this.map = null;
			}

			const mapContainer = document.getElementById('map_view')
			if (!mapContainer) {
				console.error('地图容器元素不存在，稍后重试')
				setTimeout(() => {
					this.initMap()
				}, 200)
				return
			}

			if (typeof TMap === 'undefined') {
				console.error('TMap 未定义，稍后重试')
				setTimeout(() => {
					this.initMap()
				}, 200)
				return
			}

			var center = new TMap.LatLng(32.902652, 117.440006)
			this.map = new TMap.Map(mapContainer, {
				center: center,
				zoom: 15
			});

			this.markerLayer = new TMap.MultiMarker({
				map: this.map,
				styles: {
					"bicycleStyle": new TMap.MarkerStyle({
						width: 40,
						height: 40,
						src: require('@/assets/image/markers.png'),
						anchor: { x: 20, y: 40 }
					}),
					"electricStyle": new TMap.MarkerStyle({
						width: 40,
						height: 40,
						src: require('@/assets/image/diandongche.png'),
						anchor: { x: 20, y: 40 }
					})
				},
				geometries: []
			});

			this.labelLayer = new TMap.MultiLabel({
				map: this.map,
				styles: {
					"labelStyle": new TMap.LabelStyle({
						position: "top",
						offset: { x: 0, y: -50 },
						size: 13,
						color: "#3CA757",
						backgroundColor: "#fff",
						width: 120,
						height: 20,
						borderColor: "#3CA757",
						borderWidth: 1,
						borderRadius: 4,
						padding: 5,
						enableCollision: false
					})
				},
				geometries: []
			});

			this.polygonLayer = new TMap.MultiPolygon({
				map: this.map,
				styles: {
					"returnStyle": new TMap.PolygonStyle({
						color: 'rgba(255, 107, 53, 0.3)',
						showBorder: true,
						borderColor: '#ff6b35',
						borderWidth: 2
					}),
					"operationStyle": new TMap.PolygonStyle({
						color: 'rgba(60, 167, 87, 0.3)',
						showBorder: true,
						borderColor: '#3CA757',
						borderWidth: 2
					})
				},
				geometries: []
			});

			this.highlightMarkerLayer = new TMap.MultiMarker({
				map: this.map,
				styles: {
					"highlightBicycleStyle": new TMap.MarkerStyle({
						width: 52,
						height: 52,
						src: require('@/assets/image/markers.png'),
						anchor: { x: 26, y: 52 },
						color: '#FF1744'
					}),
					"highlightElectricStyle": new TMap.MarkerStyle({
						width: 52,
						height: 52,
						src: require('@/assets/image/diandongche.png'),
						anchor: { x: 26, y: 52 },
						color: '#FF1744'
					})
				},
				geometries: []
			});

			this.highlightLabelLayer = new TMap.MultiLabel({
				map: this.map,
				styles: {
					"highlightLabelStyle": new TMap.LabelStyle({
						position: "top",
						offset: { x: 0, y: -62 },
						size: 16,
						color: "#FF1744",
						backgroundColor: "#fff",
						width: 140,
						height: 24,
						borderColor: "#FF1744",
						borderWidth: 2,
						borderRadius: 4,
						padding: 5,
						enableCollision: false
					})
				},
				geometries: []
			});

			this.map.on('bounds_changed', () => {
				if (this.boundsChangeTimer) {
					clearTimeout(this.boundsChangeTimer);
				}
				this.boundsChangeTimer = setTimeout(() => {
					this.loadDevicesByBounds();
				}, 500);
			});

			console.log('Map initialized successfully');
			this.getCurrentLocation();
		},
		getCurrentLocation() {
			if (typeof TMap !== 'undefined' && TMap.service) {
				const geolocation = new TMap.service.Geolocation();
				geolocation.getLocation().then(result => {
					if (result && result.lat && result.lng) {
						const currentCenter = new TMap.LatLng(result.lat, result.lng);
						this.map.setCenter(currentCenter);
						console.log('腾讯地图定位成功:', result.lat, result.lng);
					}
				}).catch(error => {
					console.warn('腾讯地图定位失败，尝试浏览器定位:', error);
					this.getBrowserLocation();
				});
			} else {
				this.getBrowserLocation();
			}
		},
		getBrowserLocation() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						const lat = position.coords.latitude;
						const lng = position.coords.longitude;
						const currentCenter = new TMap.LatLng(lat, lng);
						this.map.setCenter(currentCenter);
						console.log('浏览器定位成功:', lat, lng);
					},
					(error) => {
						console.warn('浏览器定位失败:', error.message);
					},
					{
						enableHighAccuracy: true,
						timeout: 10000,
						maximumAge: 0
					}
				);
			} else {
				console.warn('浏览器不支持地理定位');
			}
		},
		loadDevicesByBounds() {
			if (!this.map || this.isLoadingDevices) return;

			var bounds = this.map.getBounds();
			if (!bounds) return;

			var southLat = bounds.getSouthWest().getLat();
			var northLat = bounds.getNorthEast().getLat();
			var westLng = bounds.getSouthWest().getLng();
			var eastLng = bounds.getNorthEast().getLng();

			southLat = Math.floor(southLat * 10000) / 10000;
			northLat = Math.ceil(northLat * 10000) / 10000;
			westLng = Math.floor(westLng * 10000) / 10000;
			eastLng = Math.ceil(eastLng * 10000) / 10000;

			this.isLoadingDevices = true;

			this.$http.get('/device/manager/getMapLockDeviceByBounds', {
				params: {
					queryDistributorId: this.queryDistributorId,
					southLat: southLat,
					northLat: northLat,
					westLng: westLng,
					eastLng: eastLng
				}
			}).then((res) => {
				if (res.data.code == 200) {
					this.allLockDeviceList = res.data.data || [];
					this.lockDeviceList = this.allLockDeviceList;
					this.renderDevicesInBatches(this.allLockDeviceList);
				} else {
					this.$message.error(res.data.msg)
				}
			}).catch((err) => {
				console.error('加载车锁数据失败:', err);
			}).finally(() => {
				this.isLoadingDevices = false;
			});
		},
		renderDevicesInBatches(devices) {
			if (this.renderTimer) {
				clearTimeout(this.renderTimer);
				this.renderTimer = null;
			}

			this.geometrieList = [];
			this.labelGeometries = [];
			this.currentBatchIndex = 0;
			this.pendingDevices = devices;

			this._renderNextBatch();
		},
		_renderNextBatch() {
			var start = this.currentBatchIndex;
			var end = Math.min(start + BATCH_SIZE, this.pendingDevices.length);

			if (start >= this.pendingDevices.length) return;

			for (var i = start; i < end; i++) {
				var device = this.pendingDevices[i];
				if (!device.longitude || !device.latitude) continue;

				var lockNo = device.qrNumber || device.imei || "未知编号";
				var bicycleType = device.bicycleType || 1;
				var styleId = bicycleType === 2 ? 'electricStyle' : 'bicycleStyle';
				var position = new TMap.LatLng(device.latitude, device.longitude);

				this.geometrieList.push({
					id: 'mk_' + i,
					styleId: styleId,
					position: position,
					properties: {
						title: lockNo,
						lockNo: lockNo
					}
				});

				this.labelGeometries.push({
					id: 'lb_' + i,
					styleId: 'labelStyle',
					position: position,
					content: lockNo
				});
			}

			this.currentBatchIndex = end;

			if (this.markerLayer) {
				this.markerLayer.setGeometries(this.geometrieList);
			}
			if (this.labelLayer) {
				this.labelLayer.setGeometries(this.labelGeometries);
			}

			if (this.currentBatchIndex < this.pendingDevices.length) {
				this.renderTimer = setTimeout(() => {
					this._renderNextBatch();
				}, 50);
			}
		},
		getElectronicFenceList() {
			this.$http.get('/device/manager/table/getElectronicFenceList', {
				params: {
					queryDistributorId: this.queryDistributorId
				}
			}).then((res) => {
				if (res.data.code == 200) {
					this.electronicFenceList = res.data.data;
					this.fenceGeometrieList = [];

					if (this.electronicFenceList && this.electronicFenceList.length > 0) {
						for (let index in this.electronicFenceList) {
							let fence = this.electronicFenceList[index];
							if (fence.paths && fence.paths.length > 0) {
								let polygonPaths = fence.paths.map(function (point) {
									return new TMap.LatLng(point.lat, point.lng);
								});

								let styleId = (fence.type === 2) ? 'operationStyle' : 'returnStyle';
								this.fenceGeometrieList.push({
									id: `fence_${fence.id || index}`,
									styleId: styleId,
									paths: [polygonPaths]
								});
							}
						}

						if (this.polygonLayer && this.fenceGeometrieList.length > 0) {
							this.polygonLayer.setGeometries(this.fenceGeometrieList);
							console.log('电子围栏添加成功:', this.fenceGeometrieList);
						}
					}
				}
			})
		},
		searchLock() {
			if (!this.searchLockNo) {
				this.$message.warning('请输入车锁编号');
				return;
			}

			this.$http.get('/device/manager/getMapLockDevice', {
				params: {
					queryDistributorId: this.queryDistributorId
				}
			}).then((res) => {
				if (res.data.code == 200) {
					var allDevices = res.data.data || [];
					this.matchingLocks = allDevices.filter(device => {
						if (!device.latitude || !device.longitude) return false;
						var lockNo = device.qrNumber || device.imei || "未知编号";
						return lockNo.includes(this.searchLockNo);
					});

					if (this.matchingLocks.length > 0) {
						this.currentSearchIndex = (this.currentSearchIndex + 1) % this.matchingLocks.length;
						var currentLock = this.matchingLocks[this.currentSearchIndex];

						var position = new TMap.LatLng(currentLock.latitude, currentLock.longitude);
						this.map.setCenter(position);
						this.map.setZoom(15);

						var highlightMarkerGeometries = [];
						var highlightLabelGeometries = [];
						for (var i = 0; i < this.matchingLocks.length; i++) {
							var lock = this.matchingLocks[i];
							var lockNo = lock.qrNumber || lock.imei || "未知编号";
							var pos = new TMap.LatLng(lock.latitude, lock.longitude);
							var styleId = lock.bicycleType === 2 ? 'highlightElectricStyle' : 'highlightBicycleStyle';
							highlightMarkerGeometries.push({
								id: 'hl_' + i,
								styleId: styleId,
								position: pos
							});
							highlightLabelGeometries.push({
								id: 'hl_label_' + i,
								styleId: 'highlightLabelStyle',
								position: pos,
								content: lockNo
							});
						}

						if (this.highlightMarkerLayer) {
							this.highlightMarkerLayer.setGeometries(highlightMarkerGeometries);
						}
						if (this.highlightLabelLayer) {
							this.highlightLabelLayer.setGeometries(highlightLabelGeometries);
						}

						var currentLockNo = currentLock.qrNumber || currentLock.imei || "未知编号";
						this.$message.success(`找到车锁 ${currentLockNo}，已定位到地图中心 (${this.currentSearchIndex + 1}/${this.matchingLocks.length})`);
					} else {
						this.currentSearchIndex = -1;
						if (this.highlightMarkerLayer) {
							this.highlightMarkerLayer.setGeometries([]);
						}
						if (this.highlightLabelLayer) {
							this.highlightLabelLayer.setGeometries([]);
						}
						this.$message.error('未找到匹配的车锁编号');
					}
				}
			});
		},
		onSearchInput() {
			if (!this.searchLockNo) {
				this.currentSearchIndex = -1;
				this.matchingLocks = [];
				if (this.highlightMarkerLayer) {
					this.highlightMarkerLayer.setGeometries([]);
				}
				if (this.highlightLabelLayer) {
					this.highlightLabelLayer.setGeometries([]);
				}
			}
		}
	},
}
</script>

<style scoped>
#container {
	position: relative;
	width: 100%;
	height: 100vh;
	min-height: 600px;
}

.search-container {
	position: absolute;
	top: 20px;
	left: 20px;
	z-index: 9999;
	background-color: white;
	padding: 10px;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	display: flex;
	align-items: center;
	pointer-events: auto;
}

.search-input-group {
	display: flex;
	align-items: center;
}

.search-tip {
	position: absolute;
	top: 75px;
	left: 20px;
	z-index: 9999;
	font-size: 12px;
	color: #666;
	white-space: nowrap;
	pointer-events: none;
	background-color: rgba(255, 255, 255, 0.9);
	padding: 4px 8px;
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(85, 84, 84, 0.1);
}

.device-count {
	position: absolute;
	top: 95px;
	left: 20px;
	z-index: 9999;
	font-size: 12px;
	color: #3CA757;
	white-space: nowrap;
	pointer-events: none;
	background-color: rgba(255, 255, 255, 0.9);
	padding: 4px 8px;
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(85, 84, 84, 0.1);
}

.search-input {
	width: 160px;
	padding: 6px 10px;
	border: 1px solid #ddd;
	border-radius: 4px;
	margin-right: 8px;
	font-size: 12px;
}

.search-button {
	padding: 6px 12px;
	background-color: #3CA757;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 12px;
}

.search-button:hover {
	background-color: #3CA757;
}

#map_view {
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.fence-legend {
	position: absolute;
	top: 20px;
	right: 100px;
	z-index: 9999;
	background-color: white;
	padding: 12px 16px;
	border-radius: 6px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.legend-title {
	font-size: 14px;
	font-weight: 600;
	color: #333;
	margin-bottom: 10px;
	padding-bottom: 8px;
	border-bottom: 1px solid #eee;
}

.legend-item {
	display: flex;
	align-items: center;
	margin-top: 8px;
}

.legend-color {
	width: 20px;
	height: 14px;
	border-radius: 3px;
	margin-right: 10px;
	border: 1px solid rgba(0, 0, 0, 0.1);
}

.return-color {
	background-color: #ff6b35;
}

.operation-color {
	background-color: #3CA757;
}

.legend-text {
	font-size: 13px;
	color: #666;
}
</style>

<style>
.custom-info-window {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
}

.custom-info-window .tmap-info-window-close {
	display: none !important;
}

.custom-info-window .tmap-info-window-arrow {
	display: none !important;
}

.custom-info-window .tmap-info-window-content {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
}

.custom-info-window .tmap-info-window-content div {
	padding: 4px 8px !important;
	background-color: white !important;
	border: 1px solid #ff6b35 !important;
	border-radius: 4px !important;
	font-size: 12px !important;
	color: #333 !important;
	white-space: nowrap !important;
}
</style>
